import { Box, Flex, Text, Image, useTheme, Grid } from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import Images from "./Images";

function TeamMember() {
  const { colors } = useTheme();
  const brandColor = colors.brand["900"];

  return (
    <Box marginX="auto">
      <Box bgColor="brand.600" borderRadius="50%">
        <Image src={Images.Person7} alt="team member" />
      </Box>
      <Flex direction="column" alignItems="center">
        <Box textAlign="center" mb=".5rem">
          <Text fontWeight="bold" fontSize="2xl">
            Peter Parker
          </Text>
          <Text>CEO, Founder</Text>
        </Box>
        <Grid gridTemplateColumns="repeat(4, 1fr)" gridGap="1rem">
          <FaInstagram fontSize="1.2rem" color={brandColor} />
          <FaTwitter fontSize="1.2rem" color={brandColor} />
          <FaFacebook fontSize="1.2rem" color={brandColor} />
          <FaLinkedin fontSize="1.2rem" color={brandColor} />
        </Grid>
      </Flex>
    </Box>
  );
}

export default TeamMember;
